export default "__VITE_ASSET__CC3GjK9j__"